import React, { useState } from "react";
import { Modal, Button, Form } from "react-bootstrap";

const RetireModal = ({ show, onHide, onSubmit, impress }) => {
  const [notes, setNotes] = useState("");
  const [proof, setProof] = useState(null);
  const [preview, setPreview] = useState(null);
  const [submitting, setSubmitting] = useState(false);

  const handleFileChange = (e) => {
    const file = e.target.files[0];
    if (!file) return;
    setProof(file);
    setPreview(URL.createObjectURL(file));
  };

  const resetForm = () => {
    setNotes("");
    setProof(null);
    setPreview(null);
  };

  const handleSubmit = async () => {
    if (!proof) return;
    setSubmitting(true);
    await onSubmit({ notes, proof });
    setSubmitting(false);
    resetForm();
  };

  const handleClose = () => {
    resetForm();
    onHide();
  };

  if (!impress) return null;

  return (
    <Modal show={show} onHide={handleClose} centered>
      <Modal.Header closeButton>
        <Modal.Title style={{ fontSize: 16 }}>Retire Imprest</Modal.Title>
      </Modal.Header>

      <Modal.Body>
        <p style={{ fontSize: 13, color: "#6b7280", marginBottom: 16 }}>
          You are retiring <strong>{impress.name}</strong>. Upload proof of
          purchase and add any notes.
        </p>

        <Form.Group style={{ marginBottom: 14 }}>
          <Form.Label style={{ fontSize: 13, color: "#6b7280" }}>
            Proof of Purchase <span style={{ color: "#ef4444" }}>*</span>
          </Form.Label>
          <Form.Control
            type="file"
            accept="image/*"
            onChange={handleFileChange}
            size="sm"
          />
          <Form.Text style={{ color: "#9ca3af", fontSize: 11 }}>
            Upload a photo of the item purchased as proof.
          </Form.Text>
        </Form.Group>

        {preview && (
          <div style={{ marginBottom: 14 }}>
            <img
              src={preview}
              alt="Preview"
              style={{
                width: "100%",
                borderRadius: 8,
                border: "1px solid #e5e7eb",
                maxHeight: 200,
                objectFit: "cover",
              }}
            />
          </div>
        )}

        <Form.Group>
          <Form.Label style={{ fontSize: 13, color: "#6b7280" }}>
            Notes (optional)
          </Form.Label>
          <Form.Control
            as="textarea"
            value={notes}
            onChange={(e) => setNotes(e.target.value)}
            placeholder="Any additional notes about the purchase..."
            rows={3}
            size="sm"
          />
        </Form.Group>
      </Modal.Body>

      <Modal.Footer>
        <Button variant="light" onClick={handleClose} size="sm" disabled={submitting}>
          Cancel
        </Button>
        <Button
          variant="dark"
          onClick={handleSubmit}
          size="sm"
          disabled={!proof || submitting}
        >
          {submitting ? "Retiring..." : "Confirm Retirement"}
        </Button>
      </Modal.Footer>
    </Modal>
  );
};

export default RetireModal;